import { useScrollPositionStore } from '../hooks/useScrollPositionStore';

let isScrollListenerInitialized = false;
let scrollHandler: (() => void) | null = null;

export const initializeScrollListener = (): (() => void) => {
  if (isScrollListenerInitialized) {
    return () => {
      if (scrollHandler) {
        window.removeEventListener('scroll', scrollHandler);
        scrollHandler = null;
        isScrollListenerInitialized = false;
      }
    };
  }
  isScrollListenerInitialized = true;

  const store = useScrollPositionStore.getState();

  store.initializeFromScrollPosition(window.scrollY);

  scrollHandler = () => {
    store.updateScrollPosition(window.scrollY);
  };
  window.addEventListener('scroll', scrollHandler);

  // Handle async scroll restoration on mobile browsers
  // Check scroll position after mount to catch restoration that happens after component mount
  requestAnimationFrame(() => {
    const currentScrollY = window.scrollY;
    const { lastScrollY } = useScrollPositionStore.getState();
    if (currentScrollY !== lastScrollY) {
      store.updateScrollPosition(currentScrollY);
    }
  });

  return () => {
    if (scrollHandler) {
      window.removeEventListener('scroll', scrollHandler);
      scrollHandler = null;
      isScrollListenerInitialized = false;
    }
  };
};
